const reservedSubdomains = new Set(['app', 'api', 'auth', 'www', 'localhost']);

export default function clientSubdomain(hostname = window.location.hostname): string | null {
  if (/^\d{1,3}(?:\.\d{1,3}){3}$/.test(hostname)) {
    return null;
  }

  const subdomain = hostname.split('.')[0].toLowerCase();

  if (
    reservedSubdomains.has(subdomain)
    || !/^(?!-)[a-z0-9-]{1,63}(?<!-)$/.test(subdomain)
  ) {
    return null;
  }

  return subdomain;
}

export function clientSubdomainMatches(
  authenticatedSubdomain: string | null | undefined,
  hostname = window.location.hostname,
): boolean {
  const requestedSubdomain = clientSubdomain(hostname);
  const normalizedAuthenticatedSubdomain = authenticatedSubdomain?.trim().toLowerCase();

  return !requestedSubdomain
    || requestedSubdomain === normalizedAuthenticatedSubdomain;
}
